import React, { ReactElement, useEffect, useState } from 'react'
import { Row } from './row'
import './style.scss'
import {
  JSONFileMunicipalCouncil,
  PercentagePerParty
} from 'types/gemeindeRatWahlanteileFile'
import { HeaderFields } from 'types/headerFields'
import { Header } from 'components/header'
import { CheckedIcon } from 'components/icons/checkedIcon'
const othersPartyName = 'Andere'
export default function index(): ReactElement {
  const [data, setData] = useState<PercentagePerParty | null>()
  const [metaData, setMetaData] = useState<HeaderFields | null>()
  useEffect(() => {
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/erneuerungswahlen-zh-2022/gemeinderat-wahlanteile.json'
    ).then(res =>
      res.json().then((fetchedData: JSONFileMunicipalCouncil) => {
        setMetaData({
          title: fetchedData.meta.voterShares.title,
          description: fetchedData.meta.voterShares.description,
          doneMunicipalCouncil: fetchedData.meta.doneMunicipalCouncil,
          countStatus: fetchedData.meta.countStatus
        })
        // set "other" parties as last entry
        const others = fetchedData.percentagePerParty.find(
          row => row.party === othersPartyName
        )
        const dataWithoutOthers = fetchedData.percentagePerParty.filter(
          row => row.party !== othersPartyName
        )

        const sortedData = dataWithoutOthers.sort(
          (a, b) => b.waehlerAnteil - a.waehlerAnteil
        )
        if (others) {
          sortedData.push(others)
        }
        setData(sortedData)
      })
    )
  }, [])
  return (
    <>
      {metaData && (
        <Header
          title={metaData.title}
          description={metaData.description}
          doneMunicipalCouncil={metaData.doneMunicipalCouncil}
          countStatus={metaData.countStatus}
        />
      )}

      <div className='table'>
        {data &&
          data.map(row => {
            return (
              <Row
                key={row.party}
                quorumReached={row.quorumReached}
                party={row.party}
                percentage={row.waehlerAnteil}
                changePercentage={
                  row.party !== othersPartyName
                    ? row.changeWaehlerAnteil
                    : undefined
                }
                color={row.color}
              />
            )
          })}
      </div>
      <div className='legend'>
        <CheckedIcon /> 5% Quorum erreicht
      </div>
    </>
  )
}
